import { JSX } from "react";
import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";

import { asTitle } from "utils/Utils";

import EditOrganisationGeneralForm from "./general/EditOrganisationGeneralForm";

const NEW_ORGANISATION = {
	name: "",
	slogan: "",
	description: "",
	type: "",
	smallLogo: "",
	largeLogo: "",
	vatIdentification: "",
	streetName: "",
	streetNumber: "",
	postalCode: "",
	city: "",
	country: "",
	email: "",
	phoneNumber: ""
};

export default function CreateOrganisationPage(): JSX.Element {
	const { t } = useTranslation();

	return (
		<>
			<Typography variant="h1">
				{asTitle(t("createOrganisation"))}
			</Typography>

			<EditOrganisationGeneralForm {...NEW_ORGANISATION} />
		</>
	);
}
